<script setup>
    import { FingerPrintIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <FingerPrintIcon />
</template>
